var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormItemContainer',{staticClass:"textarea",attrs:{"title":_vm.title}},[_c('v-textarea',_vm._b({attrs:{"rules":_vm.myRules,"label":_vm.label},on:{"input":_vm.onInput}},'v-textarea',{ ..._vm.$attrs, ..._vm.$props, label: '' },false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }